export default __webpack_public_path__ + "static/media/fridge1-before2-1024w.0c86a508.avif";